// Theme barrel export - Minimal Content-First Design
export { SPACING } from './spacing';
export { FONT_FAMILIES } from './fonts';
export { FONT_SIZES, TYPOGRAPHY, withWeight } from './typography';
export { BORDER_RADIUS } from './borderRadius';
export { ON_COLOR, GOOGLE_LOGO, MAP_CLUSTER_FILL, PROPERTY_CLUSTER_FILL } from './colors';
export { durations, easings, MOTION_CSS_VARS } from './motion';
export { hexToRgb, hexWithAlpha, mixHex, relativeLuminance } from './colorMix';
export { ELEVATION } from './elevation';
export {
  CATEGORY_ICONS,
  CATEGORY_GLYPH_PATHS,
  TRIANGLE_PATH,
  HOUSE_PATH,
  COMMUNITY_BADGE_PATH,
} from './categoryIcons';
export {
  CONTENT_MAX_WIDTH,
  NARROW_MAX_WIDTH,
  SIDEBAR_WIDTH,
  SIDEBAR_RAIL_WIDTH,
  SIDEBAR_FOOTER_HEIGHT,
  DETAIL_PANEL_WIDTH,
  PRESENTATION_PANEL_WIDTH,
  DESKTOP_CONTENT_MAX_WIDTH,
  READING_MAX_WIDTH,
  SHELL_HEADER_HEIGHT,
  SHELL_RULE_WIDTH,
  DOCK_PANEL_TRANSITION_MS,
  MIN_MAP_WIDTH,
  COMPANION_PANEL_WIDTH,
  PLAN_PANEL_HEADER_HEIGHT,
  DOCK_TAB_WIDTH,
} from './layout';
export { Z_INDEX } from './zIndex';
export { useTheme } from '../hooks/useTheme';
